export const PRODUCT_GALLERY_ASPECT_RATIO_DESKTOP = '46%';
export const PRODUCT_GALLERY_ASPECT_RATIO_MOBILE = '86%';
export const PRODUCT_GALLERY_MAP_ZOOM = 12;
export const SCREEN_SIZE_TO_ENABLE_MIN_MAP_HEIGHT = 650;
export const MIN_MAP_HEIGHT = 500;

export const ACTIVE_PIN_ICON = `map-pin-active`;
export const INACTIVE_PIN_ICON = `map-pin-inactive`;
